<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" *ngIf="result">
    <h2 class="section-title">Resposta de formulário</h2>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography flex flex-col gap-4 h-full" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <span *ngIf="patientName">
        <b> Paciente:</b> <a [href]="'/patient/' + patientId"> {{ patientName }}</a></span
    >
    <form-answer-viewer
        [response]="result"
        *ngIf="result"
        [horizontalEvolution]="horizontalEvolution"
    ></form-answer-viewer>
</mat-dialog-content>
